import React, { useState } from 'react';
import { Layout, Menu, Avatar, Dropdown } from 'antd';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import {
  HomeOutlined,
  FileTextOutlined,
  PlusOutlined,
  SearchOutlined,
  MonitorOutlined,
  UserOutlined,
  LogoutOutlined,
} from '@ant-design/icons';
import { useAuthStore } from '../stores/authStore';
import UserMenu from './UserMenu';

const { Header, Sider, Content } = Layout;

const AppLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuthStore();

  // 用户菜单项
  const userMenuItems = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: 'Profile Settings',
    },
    {
      key: 'billing',
      icon: <UserOutlined />,
      label: 'Credits Management',
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Logout',
    },
  ];

  // // 导航菜单项
  // const menuItems = [
  //   {
  //     key: '/',
  //     icon: <HomeOutlined />,
  //     label: '主页',
  //   },
  //   {
  //     key: '/app/notes',
  //     icon: <FileTextOutlined />,
  //     label: '笔记库',
  //   },
  //   {
  //     key: '/app/create',
  //     icon: <PlusOutlined />,
  //     label: '新建笔记',
  //   },
  //   {
  //     key: '/app/search',
  //     icon: <SearchOutlined />,
  //     label: '搜索',
  //   },
  //   {
  //     key: '/app/logs',
  //     icon: <MonitorOutlined />,
  //     label: '远端日志',
  //   },
  // ];

  const handleMenuClick = (e) => {
    navigate(e.key);
  };

  const handlePurchaseClick = () => {
    // setPurchaseModalVisible(true);
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0 24px' }}>
        <div className="logo" style={{ fontSize: '1.5rem', color: 'white', fontWeight: 'bold' }}>
          KbAI
        </div>
        <UserMenu userName={user?.username} />
      </Header>
      {/* <Layout>
        <Sider width={200} theme="light">
          <Menu
            mode="inline"
            selectedKeys={[location.pathname]}
            style={{ height: '100%', borderRight: 0 }}
            items={menuItems}
            onClick={handleMenuClick}
          />
        </Sider>
        <Content style={{ padding: '24px', minHeight: 280 }}>
          <Outlet />
        </Content>
      </Layout> */}
    </Layout>
  );
};

export default AppLayout; 
